import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivitiesPageComponent } from './activities-page/activities-page.component';
import { AboutPageComponent } from './about-page/about-page.component';
import { HomePageComponent } from './home-page/home-page.component';
import { SingleActivityPageComponent } from './activities-page/single-activity-page/single-activity-page.component';
import { AbchestComponent } from './online-games/abchest/abchest.component';
import { ColoringSectionPageComponent } from './coloring-section-page/coloring-section-page.component';
import { SingleColoringPageComponent } from './coloring-section-page/single-coloring-page/single-coloring-page.component';
import { CartoonsPageComponent } from './cartoons-page/cartoons-page.component';
import { PrivacyPolicyPageComponent } from './privacy-policy-page/privacy-policy-page.component';
import { SongsPageComponent } from './songs-page/songs-page.component';
import { SingleSongPageComponent } from './songs-page/single-song-page/single-song-page.component';
import { ContactPageComponent } from './contact-page/contact-page.component';
import { SingleCartoonPageComponent } from './cartoons-page/single-cartoon-page/single-cartoon-page.component';
import { PatruImaginiComponent } from './online-games/patru-imagini/patru-imagini.component';
import { ReviewsPageComponent } from './reviews-page/reviews-page.component';
import { SingleReviewPageComponent } from './reviews-page/single-review-page/single-review-page.component';
import { BlogPageComponent } from './blog-page/blog-page.component';
import { BlogPostPageComponent } from './blog-page/blog-post-page/blog-post-page.component';
import {SearchPageComponent} from './search-page/search-page.component';
import { CraftsPageComponent } from './crafts-page/crafts-page.component';
import { SingleCraftPageComponent } from './crafts-page/single-craft-page/single-craft-page.component';
import { AudioPageComponent } from './audio-page/audio-page.component';
import { SingleAudioPageComponent } from './audio-page/single-audio-page/single-audio-page.component';
import { UneltePageComponent } from './unelte-page/unelte-page.component';


const routes: Routes = [
  {
    path: 'home',
    component: HomePageComponent,
  },
  {
    path: 'unelte',
    component: UneltePageComponent,
  },
  {
    path: 'activities',
    component: ActivitiesPageComponent,
  },
  {
    path: 'activities/:slug',
    component: SingleActivityPageComponent
  },
  {
    path: 'reviews',
    component: ReviewsPageComponent,
  },
  {
    path: 'reviews/:slug',
    component: SingleReviewPageComponent
  },
  {
    path: 'blog',
    component: BlogPageComponent,
  },
  {
    path: 'blog/:slug',
    component: BlogPostPageComponent
  },
  {
    path: 'coloring',
    component: ColoringSectionPageComponent,
  },
  {
    path: 'coloring/:slug',
    component: SingleColoringPageComponent
  },
  {
    path: 'crafts',
    component: CraftsPageComponent,
  },
  {
    path: 'crafts/:slug',
    component: SingleCraftPageComponent
  },
  {
    path: 'about',
    component: AboutPageComponent,
  },
  {
    path: 'contact',
    component: ContactPageComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyPageComponent,
  },
  {
    path: 'search',
    component: SearchPageComponent,
  },
  {
    path: 'cartoons',
    component: CartoonsPageComponent,
  },
  {
    path: 'cartoons/:slug',
    component: SingleCartoonPageComponent,
  },
  {
    path: 'audio',
    component: AudioPageComponent,
  },
  {
    path: 'audio/:slug',
    component: SingleAudioPageComponent,
  },
  {
    path: 'songs',
    component: SongsPageComponent,
  },
  {
    path: 'songs/:slug',
    component: SingleSongPageComponent
  },
  {
    path: 'online-games',
    children: [
      {
        path: 'abchest',
        component: AbchestComponent
      },
      {
        path: 'patru-imagini',
        component: PatruImaginiComponent
      }
    ]
  },
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  // top doesn't work
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
